import { configureStore } from "@reduxjs/toolkit";
import { setupListeners } from "@reduxjs/toolkit/query";

import { advertiseApi } from "../Services/AdvertiseService";

export const store = configureStore({
  reducer: {
    // Add the generated reducer as a specific top-level slice

    [advertiseApi.reducerPath]: advertiseApi.reducer,
  },
  // Adding the api middleware enables caching, invalidation, polling,
  // and other useful features of `rtk-query`.
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware().concat(advertiseApi.middleware),
});

setupListeners(store.dispatch);
